// extracted by mini-css-extract-plugin
export default {"main":"FuelDynamic_main__k6CNJ","imageSideFlex":"FuelDynamic_imageSideFlex__YuixL","sideContent":"FuelDynamic_sideContent__nIWd3"};